module.exports = __webpack_public_path__ + "static/media/tire.a866219e.svg";